import { map, filter, withLatestFrom } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Store, select } from '@ngrx/store';

import { getOpenPlatformProducts } from '@ordersnproducts/modules/order-builder/modules/rms-specification/selectors/products.selectors';
import { SelectOptionI } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-select/models/select-option-i';
import { SelectOptionLoaderI } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-select/models/select-option-loader-i';
import { OrderBuilderState } from '@ordersnproducts/modules/order-builder/reducers/index';
import { _safe } from '@ordersnproducts/modules/shared/utils/safe-get.method';
import { makeReference, makeReferenceDescription } from '@ordersnproducts/utils/mix-reference';
import { getSelectedBusinessLine } from '@ordersnproducts/modules/order-builder/reducers/index';

@Injectable()
export class ProductsOptionsLoaderOpenPlatformService implements SelectOptionLoaderI {
  constructor(private store: Store<OrderBuilderState>) {}

  /**
   * Provides an observable of the products
   * @return {Observable<SelectOptionI[]>}
   */
  loadOptions(): Observable<SelectOptionI[]> {
    return this.store.pipe(
      select(getOpenPlatformProducts),
      filter(availableProducts => availableProducts.length > 0),
      map(availableProducts => {
        return availableProducts.map(product => {
          return {
            id: product.productCode.replace(/^0+/, ''),
            name: `${product.productCode.replace(/^0+/, '')} / ${product.productDesc}`,
          };
        });
      }),
    );
  }
}

@Injectable()
export class MixReferencesOptionsLoaderOpenPlatformService implements SelectOptionLoaderI {
  constructor(private store: Store<OrderBuilderState>) {}

  /**
   * Provides an observable of the products
   * @return {Observable<SelectOptionI[]>}
   */
  loadOptions(): Observable<SelectOptionI[]> {
    return this.store.pipe(
      select(getOpenPlatformProducts),
      filter(availableProducts => availableProducts.length > 0),
      withLatestFrom(this.store.pipe(select(getSelectedBusinessLine))),
      map(([availableProducts, businessLine]) => {
        return availableProducts.map(product => {
          return {
            id: makeReference(product),
            name: makeReferenceDescription(product, businessLine.productTypeCode),
          };
        });
      }),
    );
  }
}
